__webpack_require__.p = "https://bpsdm.kemenhub.go.id/setkomskk/";